import { useState } from 'react'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import useTranslation from '../../../hooks/useTranslation'

import NavLanguage from '../NavLanguage'
import NavNotification from '../NavNotification'
import NavProfile from '../NavProfile'
import NavToggler from '../../svgs/NavToggler'
import Phone from '../../svgs/phone'
import MobileSideNav from '../MobileSideNav'
import MenuContent from './MenuContent'

const SUPPORT_PHONE_NUMBER = '0282944581'
const SUPPORT_PHONE_LINK = `tel:${SUPPORT_PHONE_NUMBER}`

const HeaderNav = ({ collapsed, setCollapsed }) => {
  const { t } = useTranslation()
  const { dashboardTitle } = useSelector((state) => state.theme)

  const [sideNavOpen, setSideNavOpen] = useState(false)

  return (
    <>
      <div className='flex justify-between items-center'>
        <div className='flex items-center'>
          <NavToggler
            style='lg:hidden mr-8 cursor-pointer'
            onClick={() => setSideNavOpen(true)}
          />
          {collapsed ? (
            <MenuUnfoldOutlined
              className='hidden lg:block mr-16 text-3xl text-black translate-y-[-2px] cursor-pointer'
              onClick={() => setCollapsed(!collapsed)}
            />
          ) : (
            <MenuFoldOutlined
              className='hidden lg:block mr-16 text-3xl text-black translate-y-[-2px] cursor-pointer'
              onClick={() => setCollapsed(!collapsed)}
            />
          )}
          <p className='font-bold text-base md:text-2xl truncate mb-0'>
            {t(dashboardTitle)}
          </p>
        </div>

        <div className='flex items-center'>
          <NavLanguage />
          <a
            className='flex items-center justify-center bg-green_150 rounded-lg w-[40px] h-[40px] ltr:ml-8 ltr:mr-20 lg:ltr:mr-24 sm:ltr:mr-40 rtl:ml-40 rtl:mr-8 cursor-pointer'
            href={SUPPORT_PHONE_LINK}
            aria-label='Chiama Assistenza SmartCAF'
          >
            <Phone width={20} height={20} />
          </a>
          <NavNotification />
          <NavProfile />
        </div>
      </div>

      <MobileSideNav open={sideNavOpen} setOpen={setSideNavOpen}>
        <MenuContent onNavigate={() => setSideNavOpen(false)} />
      </MobileSideNav>
    </>
  )
}

export default HeaderNav
